import React from "react";
import "../carousel/Carousel.css";

export const Card = ({
  title,
  color,
  textColor,
  number,
  numberColor,
  totalColor,
}) => {
  return (
    <div
      className="group w-44 h-16 md:w-1/5 cursor-pointer border-t-4 my-6 border-blue-900 shadow-md"
      style={{ borderColor: "#002147" }}
    >
      <div className="info__hover border-8 border-white group-hover:border-gray-200 shadow-sm rounded-sm">
        <div
          className={`  bg-${
            color ? color : "white"
          } p-3 md:p-6  group-hover:bg-blue-900  flex justify-between items-center`}
        >
          <div>
            <p
              className={`uppercase text-${
                textColor ? textColor : "red-800"
              } text-xs font-bold group-hover:text-gray-200`}
            >
              {title}
            </p>
            <p
              className={`mt-4 group-hover:text-gray-300 text-${
                totalColor ? totalColor : "gray-600"
              } text-sm font-semibold break-words`}
            >{`Total ${title}`}</p>
          </div>
          <div>
            <p
              className={`text-2xl font-semibold text-${
                numberColor ? numberColor : "purple-700"
              } group-hover:text-gray-300`}
            >
              {number}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const InfoCard = () => {
  return (
    <div className="grid grid-cols-2 md:flex justify-between gap-x-1 mb-10">
      <Card title="Students" number="950" />
      <Card
        title="Teachers"
        color="blue-900"
        textColor="gray-200"
        numberColor="gray-200"
        totalColor="gray-200"
        number="35"
      />
      <Card title="Staff" number="10" />
      <Card title="Parents" number="210" />
    </div>
  );
};

export default InfoCard;
